<template>

    <Modal ref="modal">
        <template #head>
            {{ t('privacy_policy_head') }}
        </template>
        <template #body>
            {{ t('privacy_policy_text') }}
            <br>
            <br>

            <button class="btn btn--accept" @click="cookieAcceptClick">{{ t('privacy_policy_accept') }}</button>
            <button class="btn btn--link">{{ t('privacy_policy') }}</button>
        </template>
    </Modal>

    <div class="panel">

    </div>

</template>

<script>
import Modal from "@/Library/Components/Modal.vue";
import ControllLang from "@/Library/Controll/Lang.vue";
import {mapActions, mapState} from "vuex";

export default {
    name: "Cookie",
    components: {Modal},
    mixins: [ControllLang],
    computed: {
        ...mapState('app', ['cookie'])
    },
    methods: {
        ...mapActions('app', ['cookieAccept']),

        cookieAcceptClick() {
            this.cookieAccept()

            this.$refs.modal.close();
        }
    },
    mounted() {

        console.log(this.cookie)

        if (this.cookie === 'waiting')
            this.$refs.modal.open()

    }
}
</script>

<style scoped lang="scss">

.btn {
  align-items: center;
  justify-content: center;
  padding: 10px 20px 12px;
  font-size: 1rem;
  border-radius: 100px;
  cursor: pointer;

  &--link {
    background-color: transparent;

  }

  &--accept {

    background-color: rgb(73, 78, 155);
    color: #fff;

    .contrast & {
      background-color: yellow;
    }
  }

}


</style>